import React from 'react';
import { UserAgentApplication } from 'msal';

import SocialLoginButtonView from './SocialLoginButtonView';
import { defaultErrorMessage, ErrorWithHumanMessage } from '../../errors';
import appUrl from '../appUrl';
import {
  socialLoginButtonDefaultProps,
  socialLoginButtonProps,
} from './propTypes';
import withTranslations from '../../components/utils/Translations/withTranslations';
import translatePropTypes from '../../translatePropTypes';

const MS_GRAPH_API_SCOPES = ['user.read', 'mail.send'];

@withTranslations
export default class MicrosoftLoginButton extends React.PureComponent {
  static propTypes = {
    ...socialLoginButtonProps,
    ...translatePropTypes,
  };

  static defaultProps = {
    ...socialLoginButtonDefaultProps,
  };

  componentDidMount() {
    this.msal = this.initMicrosoftLogin();
  }

  initMicrosoftLogin() {
    const { completionPath } = this.props;

    return new UserAgentApplication(
      window.App.microsoftClientId,
      null,
      this.continueMicrosoftLogin,
      {
        cacheLocation: 'localStorage',
        redirectUri: appUrl(completionPath),
        navigateToLoginRequestUrl: false,
      },
    );
  }

  handleInitiateLogin = () => {
    this.msal.loginRedirect(MS_GRAPH_API_SCOPES);
  };

  continueMicrosoftLogin = (errorDesc, token, error) => {
    const { onLogin, onLoginError, t } = this.props;
    let errorMessage = defaultErrorMessage;

    if (error) {
      if (error === 'access_denied') {
        errorMessage = t('Login Cancelled');
      } else {
        const description = errorDesc || 'no description';
        console.error(`MS Login error: [${error}]: ${description}`);
      }

      return onLoginError(new ErrorWithHumanMessage(errorMessage));
    }

    if (token) {
      onLogin(token);
    }
  };

  render() {
    const { disabled, loading, className, titleTemplate } = this.props;
    return (
      <SocialLoginButtonView
        className={className}
        disabled={disabled}
        loading={loading}
        titleTemplate={titleTemplate}
        type="MICROSOFT"
        onClick={this.handleInitiateLogin}
      />
    );
  }
};
